<template>
  <div class="about">
    <div class="header-title-dark">
      <section class="container">
        <h1>{{about.hero.title}}</h1>
      </section>
    </div>

    <section class="about-content">
      <div class="text-content container">
        <h2>{{about.mainContent.history.heading}}</h2>
        <p v-for="(paragraph, index) in about.mainContent.history.content" 
               :key="index"
               :class="{ 'first-paragraph': index === 0 }">
              {{ paragraph }}
            </p>
        

      </div>
      
    </section>

    <section class="team-intro">
      <div class="content container mt-lg mb-xl">
        <h2>{{about.mainContent.teamIntro.heading}}</h2>
        <p>{{ about.mainContent.teamIntro.intro }}</p>
        <ul>
          <li v-for="(item, index) in about.mainContent.teamIntro.list"
              :key="index">
            {{ item }}
          </li>
        </ul>
        <p>{{ about.mainContent.teamIntro.conclusion }}</p>
      </div>
    </section>
  </div>

  
  <div class="bg-blue-dark py-xl">
    <div class="content container" id="team-content">
      
      <h1>Our Team</h1>
      <div class="team-grid">
        <TeamMember
          v-for="member in teamMembers"
          :key="member.name"
          v-bind="member"
        />
      </div>
    </div>
  </div>


</template>
<script setup>
import about from '@/content/about.yml';
import team from '@/content/team.yml';
import TeamMember from '@/components/TeamMember.vue';
import { usePageHead } from '@/composables/usePageHead';


const teamMembers = team.team;
usePageHead(about)

</script>
<style lang="scss" scoped>

.team-content {
  max-width: $container-width;
  margin: 0 auto;
  padding: $spacing-xl $spacing-md;
  > .team-grid {
    > * {
      margin-bottom: $spacing-xl;
    }
  }
  @include media-down(md) {
    padding: $spacing-lg $spacing-md;
    .team-grid {
      grid-template-columns: 1fr;
    }
  }
} 
</style>
